module.exports = __webpack_public_path__ + "assets/img/c0f8584ea2cbc4461d30bfee60fe7489.svg";